import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase, markWaitlistUserConverted } from '../services/supabase';
import { ROUTES } from '../constants';

const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleAuthCallback = async () => {
            try {
                console.log('Auth callback triggered');
                console.log('Current location:', location);
                console.log('Hash:', location.hash);
                console.log('Search:', location.search);

                // Check if we have a hash fragment with access token
                if (location.hash) {
                    // Parse the hash fragment
                    const hashParams = new URLSearchParams(location.hash.substring(1));
                    const accessToken = hashParams.get('access_token');
                    const refreshToken = hashParams.get('refresh_token');

                    if (accessToken) {
                        console.log('Found access token in hash, setting session');
                        // Set the session manually
                        const { data, error } = await supabase.auth.setSession({
                            access_token: accessToken,
                            refresh_token: refreshToken || '',
                        });

                        if (error) {
                            console.error('Error setting session:', error);
                            navigate(ROUTES.LOGIN);
                            return;
                        }

                        if (data.session && data.user) {
                            console.log('Session set successfully, redirecting to dashboard');
                            // Check if user was on waitlist and mark as converted
                            await markWaitlistUserConverted(data.user.email || '', data.user.id, 'google_oauth');
                            navigate(ROUTES.DASHBOARD);
                            return;
                        }
                    }
                }

                // Fallback: try to get the session normally
                const { data, error } = await supabase.auth.getSession();

                if (error) {
                    console.error('Auth callback error:', error);
                    navigate(ROUTES.LOGIN);
                    return;
                }

                if (data.session && data.session.user) {
                    console.log('Authentication successful, redirecting to dashboard');
                    // Check if user was on waitlist and mark as converted
                    await markWaitlistUserConverted(data.session.user.email || '', data.session.user.id, 'google_oauth');
                    navigate(ROUTES.DASHBOARD);
                } else {
                    console.log('No session found, redirecting to login');
                    navigate(ROUTES.LOGIN);
                }
            } catch (error) {
                console.error('Error handling auth callback:', error);
                navigate(ROUTES.LOGIN);
            }
        };

        // Add a small delay to ensure the page is fully loaded
        const timer = setTimeout(handleAuthCallback, 100);
        return () => clearTimeout(timer);
    }, [navigate, location]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Completing authentication...</p>
                <p className="text-sm text-gray-500 mt-2">Please wait while we process your login.</p>
            </div>
        </div>
    );
};

export default AuthCallback;
